import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { OutputService } from './vscode/src/vs/workbench/contrib/output/browser/outputServices.js';
import { IOutputService } from 'vscode/vscode/vs/workbench/services/output/common/output.service';
import { OutputChannelModelService } from './vscode/src/vs/workbench/contrib/output/common/outputChannelModelService.js';
import { IOutputChannelModelService } from 'vscode/vscode/vs/workbench/contrib/output/common/outputChannelModelService.service';
import getServiceOverride$1 from '@codingame/monaco-vscode-log-service-override';
import './vscode/src/vs/workbench/contrib/output/browser/output.contribution.js';

function getServiceOverride(logLevel) {
    return {
        ...getServiceOverride$1(logLevel),
        [( IOutputService.toString())]: new SyncDescriptor(OutputService, undefined, true),
        [( IOutputChannelModelService.toString())]: new SyncDescriptor(OutputChannelModelService, undefined, true)
    };
}

export { getServiceOverride as default };
